<div class="content-pane readable">
  <div class="content">
    <div class="content-body">
      <div class="content-main">
        <div class="meta-header">
          <h3>
            Project Details and Related Resources
            <ng-content select="[project-details-actions]"></ng-content>
          </h3>
        </div>
        <div class="content-container">
          <div class="content-header">
            <h2 class="content-title">{{ project().name }}</h2>
          </div>

          <div class="content-toolbar">
            @if (project().web_page_urls?.length > 0) {
              <a
                [href]="project().web_page_urls[0]"
                target="_blank"
                rel="noopener"
                class="content-header-action toolbar-action"
              >
                <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                Visit Website
              </a>
            }

            <ng-content select="[project-toolbar-extra]"></ng-content>
          </div>

          <div class="content-body">
            <div class="description" [innerHTML]="safeDescription"></div>
          </div>

          <app-key-value-table [rowsToDisplay]="metaTableData"></app-key-value-table>

          @if (resourceTiles.length > 0) {
            <div class="related-section">
              <div class="meta-subheader">Related Resources</div>
              <app-generic-tile-list [tiles]="resourceTiles"></app-generic-tile-list>
            </div>
          }
        </div>

        <ng-content select="[private-project-documents]"></ng-content>

        <div class="meta-header">
          <h3
            >Associated Datasets
            @if (project().flags._can_upload_data) {
              <span class="action-button">
                <a [routerLink]="pdeRoutes.datasetAdd(project().id)" mat-button class="edit-button">
                  <mat-icon class="material-symbols-outlined">add</mat-icon>
                  Add
                </a>
              </span>
            }
          </h3>
        </div>

        <div class="content-container">
          @if (datasetTiles.length > 0) {
            <app-generic-tile-list [tiles]="datasetTiles"></app-generic-tile-list>
          } @else {
            No datasets have been added for this project.
          }
        </div>
      </div>
      @if (showSidebar) {
        <div class="content-sidebar">
          <div class="access-section">
            <ng-content select="[project-access]">
              <ng-content select="[project-permissions]"></ng-content>
              <ng-content select="[project-visibility]"></ng-content>
            </ng-content>
          </div>
        </div>
      }
    </div>
  </div>
</div>
